export const STORAGE_KEY_PREFIX = 'data-grid';

export const createStorageKey = (componentId: string): string =>
  `${STORAGE_KEY_PREFIX}:${componentId}`;
